export function getStatusIcon(status: string | null | undefined): string {
	if (!status) return "";

	switch (status.toLowerCase()) {
		case "unread":
		case "sent":
		case "delivered":
		case "scheduled":
		case "readyforreview":
			return "icon-calendar-check-stroke";
		case "inprogress":
		case "processing":
			return "icon-refresh-clockwise";
		case "completed":
		case "reviewed":
			return "icon-check-big";
		case "notstarted":
			return "mdi-timer-sand";
		default:
			return "";
	}
}

/** The color family a session or project status is shown in (StatusIndicator.vue). */
export type StatusTone = "neutral" | "progress" | "review" | "done";

export function getStatusTone(status: string | null | undefined): StatusTone | undefined {
	if (!status) return undefined;

	switch (status.toLowerCase()) {
		case "notstarted":
		case "unread":
		case "sent":
		case "delivered":
		case "scheduled":
			return "neutral";
		case "inprogress":
		case "processing":
			return "progress";
		case "readyforreview":
			return "review";
		case "completed":
		case "reviewed":
			return "done";
		default:
			return undefined;
	}
}

/** Theme color for a status label, for Vuetify's text-<color> class (e.g. "text-status-progress"). */
export function getStatusTextColor(status: string | null | undefined): string | undefined {
	const tone = getStatusTone(status);
	if (!tone) return undefined;
	return tone === "review" ? "brand" : `status-${tone}`;
}
